import { isEmpty } from '@ember/utils';

const LIQUID_REGEX = /({{.*?}}|{%.*?%})/i;

export default function hasLiquid(value: string) {
  return value?.match && !isEmpty(value.match(LIQUID_REGEX));
}
